(() => {
  const pushEvent = (eventName, label, problem) => {
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, vc_label: label || '', vc_problem: problem || '' });
    document.dispatchEvent(new CustomEvent('vc:commerce', { detail: { event: eventName, label: label || '', problem: problem || '' } }));
  };
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-vc-event]');
    if (!target) return;
    const section = target.closest('[data-vc-problem]');
    pushEvent(target.dataset.vcEvent, target.dataset.vcLabel, section ? section.dataset.vcProblem : '');
  });
  const seen = new WeakSet();
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || seen.has(entry.target)) return;
        seen.add(entry.target);
        const section = entry.target.closest('[data-vc-problem]');
        pushEvent(entry.target.dataset.vcImpression, '', section ? section.dataset.vcProblem : '');
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-vc-impression]').forEach((el) => observer.observe(el));
  }
})();
